<div class="font-20 semibold mtb-20">
  <font class="font-required">*</font>
  Office Email Verification
  <font class="font-required">(Required)</font>
</div>
@if (!showMutiplePanel) {
  <div class="container mb-10">
    Office email addresses are for employees of organizations that have a relationship with the Department of Education.
    Department communications related to the work you do for the organization are sent to your office email address, not
    your personal email address.
    <br /><br /><b>How your office email is used:</b> Your office email may be published in the Ohio Educational Directory
    System (OEDS), an application that allows public access to information about Ohio’s K-12 organizations. You may select
    the Private option to prevent publication of your office email address in OEDS.
    <br /><br />Please select only one of the following options.
  </div>
}
<div class="divider gray-800"></div>
@if (!showMutiplePanel) {
  <div>
    @if (tokenItem?.ohidEmail!=officeEmail && officeEmail) {
      <div class="container radio-button radio-bg adjust mt-5">
        <input (change)="toggleshowOfficeOtherId()" id="office-2" name="office" type="radio" value="no-issues"
          [checked]="cService.officeEmailOption=='office-2'">
          <label class="gray-300 click-white display" for="office-2">
            <span class="pl-40">{{officeEmail}}</span>
          </label>
        </div>
      }
      @if (showOfficeOtherId && tokenItem?.ohidEmail!=officeEmail && officeEmail) {
        <div class="fade  mt-5 mb-5 relative">
          <div class="ds-text-field" style="margin-bottom: 0px;">
            <input class="ds-text-field__input" id="officeEmail" type="text" name="officeEmail" autocomplete="off" value=""
              required="" [(ngModel)]="reEnterExEmail">
              <label for="firstName" class="ds-floating-label ">*Re-Type Selected Email</label>
              <div class="field-line-ripple blue"></div>
            </div>
            <div class="basis-50 ml-20"></div>
            @if (officeEmail==reEnterExEmail) {
              <div class="check">
                <i class="fas fa-check"></i>
              </div>
            }
          </div>
          @if (officeEmail==reEnterExEmail) {
            <div class="mt-5 mb-5">
              <div class="card fluid">
                <div class="card__content align-center font-20">
                  This email has been selected as your Office email. If this looks good click next to continue.
                </div>
              </div>
            </div>
          }
        }
        @if (officeEmail==reenterOfficeEmail) {
          <div class="divider gray-800"></div>
        }
        <div class="container radio-button radio-bg adjust mt-5">
          <input (change)="toggleshowOfficeOhId()" id="office-1" name="office" type="radio" value="no-issues"
            [checked]="cService.officeEmailOption=='office-1'">
            <label class="gray-300 click-white display" for="office-1">
              <span class="pl-40">{{ tokenItem?.ohidEmail }} this is your OH|ID email</span>
            </label>
          </div>
          @if (showOfficeOhId) {
            <div class="fade  mt-5 mb-5">
              <div class="card fluid">
                <div class="card__content align-center">
                  Your OH|ID email has been selected as your Office email. If this looks good click next to continue.
                </div>
              </div>
            </div>
          }
        </div>
      }
      <div>
        @if (!showMutiplePanel) {
          <div class="container radio-button radio-bg adjust new">
            <input (change)="toggleshowOfficeAddNew()" id="office-4" name="office" type="radio" value="no-issues"
              [checked]="cService.officeEmailOption=='office-4'">
              <label class="gray-400 click-white display" for="office-4">
                @if (!isbtnclicked) {
                  <span class="pl-40">
                    Add New Office Email
                  </span>
                }
                @if (emailForm.valid && isbtnclicked) {
                  <span class="pl-40">
                    {{newEmail}}
                  </span>
                }
              </label>
            </div>
          }
          @if (showOfficeAddNew && !showMutiplePanel) {
            <div class="mt-5 mb-5">
              <div class="card fluid">
                <div class="card__content">
                  If you are associated with an educational entity or organization, your office email address may be published
                  in the Department’s educational directory and viewable by the public. You may select the Private option to
                  prevent publication of your office email address in the directory.
                </div>
              </div>
            </div>
            <form [formGroup]="emailForm">
              <div class="flex-row pb-5 fade relative">
                <div class="inline-text-field-container flex-row gap-20">
                  <div class="ds-text-field">
                    <input class="ds-text-field__input" id="newEmail" type="text" name="newEmail" autocomplete="off" value=""
                      required="" [(ngModel)]="newEmail" formControlName="newEmail">
                      <label for="address" class="ds-floating-label ">*Enter New Office Email</label>
                      <div class="field-line-ripple blue"></div>
                      @if (emailForm.get('newEmail').invalid && emailForm.get('newEmail').errors && (emailForm.get('newEmail').dirty || emailForm.get('newEmail').touched)) {
                        <div
                          >
                          @if (emailForm.get('newEmail').hasError('required')) {
                            <span id="newEmail-errmsg"
                            class="error errmsg">Enter Office Email</span>
                          }
                        </div>
                      }
                    </div>
                    <div class="ds-text-field">
                      <input class="ds-text-field__input" id="newEmail2" type="text" name="newEmail2" autocomplete="off"
                        required="" [compareEqual]="newEmail" [(ngModel)]="reenterNewEmail" formControlName="newEmail2">
                        <label for="address2" class="ds-floating-label">*Re-Enter New Office Email</label>
                        <div class="field-line-ripple blue"></div>
                        @if (emailForm.get('newEmail2').invalid && emailForm.get('newEmail2').errors && (emailForm.get('newEmail2').dirty || emailForm.get('newEmail2').touched)) {
                          <div
                            >
                            @if (emailForm.get('newEmail2').hasError('required')) {
                              <span id="newEmail2-errmsg"
                              class="error errmsg">Re-enter Office Email</span>
                            }
                          </div>
                        }
                        @if (emailForm.get('newEmail2').invalid && emailForm.get('newEmail2').errors && (emailForm.get('newEmail2').dirty || emailForm.get('newEmail2').touched)) {
                          <div
                            >
                            @if (!emailForm.get('newEmail2').hasError('required') && emailForm.get('newEmail2').hasError('compareEqual')) {
                              <span
                              id="newEmail2-errcomparemsg" class="error errmsg">Email do not match</span>
                            }
                          </div>
                        }
                        @if (newEmail && reenterNewEmail && newEmail == reenterNewEmail) {
                          <div class="check">
                            <i class="fas fa-check"></i>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="mb-10">
                      Would you like this email public or private?
                    </div>
                    <div class="flex">
                      <div class="container radio-bg radio-button new-office">
                        <input id="pp-radio-new1" name="type" type="radio" value="public" formControlName="type"
                          [(ngModel)]="ppFlag" [checked]="!isprivateflag">
                          <label class="gray-300  click-white" for="pp-radio-new1">
                            Public
                          </label>
                        </div>
                        <div class="container radio-button radio-bg new border-right pr-20">
                          <input id="pp-radio-new2" name="type" type="radio" value="private" formControlName="type"
                            [(ngModel)]="ppFlag" [checked]="isprivateflag">
                            <label class="gray-300  click-white" for="pp-radio-new2">
                              Private
                            </label>
                          </div>
                        </div>
                        <div class="container flex gap-20 justify-end">
                          <button title="Cancel" id=""
                            class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse"
                            (click)="canclenewofficemeail()">
                            <div class="btn-txt font-red bold">Cancel</div>
                          </button>
                          <button title="Add New office Email" class="rounded-full hover-blue-800 black" (click)="addnewofficeemail()"
                            [disabled]="!emailForm.valid">
                            <div class="btn-txt font-white bold">Add New office Email</div>
                          </button>
                        </div>
                      </div>
                    </form>
                  }
                  @if (!cService.isOfficeEmailRequired) {
                    <div class="container radio-button radio-bg adjust mt-5">
                      <input (change)="toggleshowOfficeDontUse()" id="office-3" name="office" type="radio" value="no-issues"
                        [checked]="cService.officeEmailOption=='office-3'">
                        <label class="gray-300 click-white display" for="office-3">
                          <span class="pl-40">I don’t want to provide my office email address</span>
                        </label>
                      </div>
                    }
                    @if (showOfficeDontUse) {
                      <div class="mt-5 mb-5">
                        <div class="card fluid">
                          <div class="card__content align-center">
                            Though you are not required to provide your office email address, we strongly encourage you do so to have an
                            alternative means for us to communicate with you via email. Please note that, we must have at least one email
                            for you in our system (personal or office email).
                          </div>
                        </div>
                      </div>
                    }
                    @if (showMutiplePanel) {
                      <div class="container">
                        <app-contact-verification-emails-multiple [oedsEmailTypeKey]="oedsEmailTypeKey" [emailList]="emailList"
                          [orgEmailList]="orgEmailList">
                        </app-contact-verification-emails-multiple>
                      </div>
                    }
                  </div>
                  <div class="divider gray-500 mtb-20"></div>
                  <div class="container flex mobile">
                    <span class="basis-33">
                      <span class="flex justify-start">
                        <button title="Back" id=""
                          class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile"
                          (click)="updatestepcount(false)">
                          <div class="btn-txt font-red bold">Back</div>
                        </button>
                      </span>
                    </span>
                    <span class="basis-33">
                      <span class="flex justify-center">
                        <!--<button id="" title="Skip Verification" class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile" (click)="cService.backtoapplication()">
                        <div class="btn-txt font-red bold">Skip Verification for Now</div>
                      </button>-->
                    </span>
                  </span>
                  <span class="basis-33">
                    <span class="flex justify-end">
                      <button title="Next" class="rounded-full hover-blue-800 black mobile" (click)=updatestepcount(true)
                        [disabled]="getIsFormvalid()">
                        <div class="btn-txt font-white bold">Next</div>
                      </button>
                    </span>
                  </span>
                </div>
                <div id="modal-1" class="modal-wrapper" role="dialog" aria-labelledby="modal-1-heading"
                  aria-describedby="modal-1-description" aria-hidden='true' tabindex="0" target="_blank">
                  <div class="modal-body rounded-20 white text-center">
                    <div class="modal-content">
                      <header>
                        <div class="modal-title" id="modal-1-heading">
                          <i Class="fas fa-minus-circle"></i> You have Unused Email(s)
                        </div>
                      </header>
                      <p class="font-14 bold font-gray-700" id="modal-1-description">
                        Office email addresses must be associated with an organization. The following email addresses do not have an
                        organization and will be removed from your account. If these email addresses are still needed, click Cancel to go back
                        and make corrections.
                      </p>
                      <div class="mb-10 border-top pt-5 mlr-30">
                        @for (uemail of unMappedEmailCollection; track uemail; let ind = $index) {
                          {{uemail.email}}
                          @if (ind!== (unMappedEmailCollection.length-1)) {
                            <span>,</span>
                          }
                        }
                      </div>
                      <div class="modal-button-container button-adjust">
                        <button title="Cancel" id=""
                          class="modalkill secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile"
                          (click)="closeConfirmModal()">
                          <div class="btn-txt font-red bold">Cancel</div>
                        </button>
                        <button title="Delete and Continue" class="rounded-full hover-blue-800 black mobile"
                          (click)="confirmunusedemailcheck()">
                          <div class="btn-txt font-white">Delete and Continue</div>
                        </button>
                      </div>
                    </div>
                    <a href="javascript:void(0)" role="button" class="modal_close modalkill" aria-label="Close this window"
                    (click)="closeConfirmModal()">close</a>
                  </div>
                  <a href="javascript:void(0)" class="modal-outside-trigger modalkill" (click)="closeConfirmModal()"></a>
                </div>
